<template>
    <div class="recharge">
        <Header ref="header" :title="title" :titleRight="titleRight" @backPage="onBack"></Header>
        <div class="walletDetails"
            v-if="walletList.length"
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-immediate-check="false"
            infinite-scroll-distance="10">
            <div class="detailList" v-for="(item, i) in walletList" :key="i">
                <p class="f26 col8E8E93" v-text="item.tradeTimeData"></p>
                <div class="ul">
                    <!-- @click="onDetail(it.tradeNo, it.tradeType)" -->
                    <div class="li p32" v-for="(it, index) in item.item"  :key="index" :class="{'borderBot': !(index === item.item.length-1)}">
                        <div class="liLeft">
                            <img :src="require('../../../../assets/img/b2b/d' + getPic(it.businessType) + '.png')" alt="">
                        </div>
                        <div class="liCenter">
                            <div class="f32 col000" >
                                {{it.businessTypeTitle}}
                                <span class="col999">
                                    ({{it.statusTitle}})
                                </span>
                            </div>
                            <div class="time f24 col8E8E93">{{ it.updateTime | formatDate2 }}</div>
                        </div>
                        <div class="liRight col000">
                            <span v-text="(it.changeType === 1) ? '+' : '-'">+</span> <span>{{ it.changeAmount | numFilter }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="loadS" class="loading">{{ isLast ? '已经是最后一条数据了' : '数据已加载完毕'}}</div>
        </div>
        <div v-else>
            <div class="wData">暂无数据</div>
        </div>
        <!-- <mt-popup v-model="popupVisible" position="bottom" :closeOnClickModal='false' class="mint-popup">
            <div class="conpon">
                <div class="head f32 col333 textCenter">
                    服务说明
                    <div class="close" @click="onClose(4)">
                        <img src="../../../../assets/img/b2b/btn_delete@2x.png" alt="">
                    </div>
                </div>
                <div class="server">
                    <p>正品保障</p>
                    <p class="f28 col333">此商品由好享家平台担保，保证有区域代理/经销权，保证正品行货</p>
                </div>
            </div>
        </mt-popup> -->
    </div>
</template>

<script>
import moment from 'moment'
import Header from '../../../common/header'
import { getAppbillInfo } from '../../api/api'
export default {
    name: 'recharge',
    components: {
        Header
    },
    data () {
        return {
            title: '账单',
            titleRight: '',
            loadShow: false,
            loadS: false,
            isLast: false,
            popupVisible: false,
            companyCode: '',
            pageNumber: 1,
            pageSize: 10,
            total: 10,
            walletList: [],
            walletObj: {}
        }
    },
    methods: {
        onBack () {
            this.$router.replace({ path: '/b2b/wallet/assets' })
        },
        onDetail (tradeNo, tradeType) {
            this.popupVisible = true
            // this.$router.push({ path: '/b2b/wallet/MyWallet/cashDetails', query: { tradeNo: tradeNo, tradeType: tradeType } })
        },
        // TODO 目前上拉加载更多没有用
        async loadMore () {
            if (this.loadShow) {
                this.isLast = false
                this.pageNumber++
                await this.getWalletDetailsList()
            } else {
                this.isLast = true
            }
        },
        getPic (key) {
            switch (key) {
                case 8:
                    return 1
                case 13:
                    return 4
                case 100:
                    return 6
                case 110:
                    return 1
                case 120:
                    return 5
                case 130:
                    return 5
                default:
                    return key
            }
        },
        getCashTitle (val) {
            if (val === 0) {
                return '手续费'
            } else if (val === 1) {
                return '支付'
            } else if (val === 2) {
                return '提现'
            } else if (val === 3) {
                return '退款'
            } else if (val === 4) {
                return '佣金'
            } else if (val === 5) {
                return '返利'
            } else if (val === 6) {
                return '充值'
            } else if (val === 7) {
                return '货款'
            } else if (val === 8) {
                return '数据迁移'
            } else if (val === 9) {
                return '营销费'
            } else if (val === 13) {
                return '满返'
            } else if (val === 110) {
                return '支付-预充'
            } else if (val === 120) {
                return '退款-预充'
            } else if (val === 130) {
                return '赎回'
            } else if (val === 10) {
                return '服务费'
            }
        },
        getStatusTitle (val) {
            let statusTitle = ''
            switch (val) {
                case 10:
                    statusTitle = '未处理'
                    break
                case 20:
                    statusTitle = '处理中'
                    break
                case 30:
                    statusTitle = '成功'
                    break
                case 40:
                    statusTitle = '失败'
                    break
                case 50:
                    statusTitle = '关闭'
                    break
                case 60:
                    statusTitle = '冻结中'
                    break
                default:
                    statusTitle = ''
            }
            return statusTitle
        },
        async getWalletDetailsList () {
            const { data } = await getAppbillInfo({
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                companyCode: this.companyCode
            })
            this.total = data.total
            data.records.forEach((v, i) => {
                let time = moment(v.createTime).format('YYYY年MM月')
                if (this.walletObj.hasOwnProperty(time)) {
                    this.walletObj[time].push(v)
                } else {
                    this.walletObj[time] = [v]
                }
            })
            this.walletList = Object.keys(this.walletObj).map(v => {
                return {
                    tradeTimeData: v,
                    item: this.walletObj[v].map(i => {
                        return {
                            ...i,
                            businessTypeTitle: this.getCashTitle(i.businessType),
                            statusTitle: this.getStatusTitle(i.status)
                        }
                    })
                }
            })
            let totalLength = this.walletList.reduce((pre, cur) => {
                return pre + cur.item.length
            }, 0)
            if (totalLength >= this.total) {
                this.loadShow = false
            } else {
                this.loadShow = true
                this.loadS = true
            }
        }
    },
    mounted () {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.companyCode = userInfo.companyCode
        this.getWalletDetailsList()
    }
}
</script>

<style lang="scss" scoped>
.recharge {
    background: #f5f5f5;
    .detailList {
        overflow: hidden;
        p {
            padding: 20px 36px 10px;
        }
        .ul {
            .li {
                display: flex;
                justify-content: flex-start;
                align-content: center;
                align-items: center;
                background: #ffffff;
                position: relative;
                .liLeft {
                    width: 80px;
                    height: 80px;
                }
                .liCenter {
                    padding-left: 24px;
                }
                .liRight {
                    flex: 1;
                    text-align: right;
                    font-size: 34px;
                }
            }
        }
    }
    .loading {
        color: #999;
        text-align: center;
        padding: 40px;
    }
    .borderBot:before {
        bottom: 2px !important;
    }
}
.mint-popup-bottom {
    width: 100%;
    background: #f5f5f5;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    .conpon {
        background: #ffffff;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        .head {
            position: relative;
            height: 108px;
            line-height: 108px;
            padding: 0 24px;
            .close {
                width: 48px;
                height: 48px;
                position: absolute;
                right: 24px;
                top: 10px;
            }
        }
    }
}
.wData {
    text-align: center;
    line-height: 80px;
    font-size: 26px;
    color: #cccccc;
}
</style>
